import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'

import EditorMain from '../components/Editor/Editor.js'

import EditorTopbar from '../components/Editor/EditorTopbar'

import EditorHintLayer from '../components/Editor/EditorHintLayer'

import EditorTab from '../components/Editor/EditorTab'
import PreviewTab from '../components/Editor/PreviewTab'
import IntegrationsTab from '../components/Editor/IntegrationsTab'
import PublishTab from '../components/Editor/PublishTab'
import PersonalityOptions from '../components/Modal/PersonalityOptions'
import Upgrade from '../components/Modal/Upgrade'

import Toast from '../common/components/Toast/Toast'
import Loader from '../components/Loader'

import languages from '../i18n/languages'

import { UTILS__ROUTER__add_query, UTILS__ROUTER__remove_query } from '../utils/router'

import { API__MEDIA, API__PROJECTS, API__PRODUCTS } from '../api'
import { PRODUCTS__SET } from '../store/actions'
import { UTILS__CONVERT_DATA_URI_TO_BINARY } from '../utils/file_reader'
import { EDITOR__MOUNT, EDITOR__UNMOUNT } from '../store/actions/editor'

import { editor_translations } from '../utils/crutchTranslations'
import { UTILS__COMMON__KEYS_CHECKER } from '../utils/common'
import copy from 'copy-to-clipboard'

const subFolder = '/legacy/editor_assets'

async function assets_script(action) {
    const srcs = [
        '/js/l.js',
        '/js/lib/jquery.js',
        '/js/lib/jscolor.min.js',
        '/js/lib/clipboard.js',
        '/js/lib/underscore.js',

        '/js/config.js',

        '/js/model/app.js',

        '/js/util/utils.js',
        '/js/util/queue.js',

        '/controls/DirectiveLoader.js',
        '/controls/AbstractControl.js',
        '/controls/TextQuickInput.js',
        '/controls/ClickAndAddToArray.js',
        '/controls/Slide.js',
        '/controls/AddHashlistElementControl.js',
        '/controls/DeleteHashlistElementControl.js',
        '/controls/OnOff.js',
        '/controls/StringControl.js',
        '/controls/Drag.js',
        '/controls/DataProvider.js',
        '/controls/TextLabel.js',
        '/controls/Alternative.js',
        '/controls/SlideGroupControl.js',
        '/controls/ChooseImage.js',

        '/js/editorui/screenManager.js',
        '/js/editorui/controlManager.js',
        '/js/editorui/workspace.js',
        '/js/editorui/resourceManager.js',
        '/js/editorui/quickControlPanel.js',

        '/start.js',
    ]

    switch (action) {
        case 'add': {
            srcs.forEach(src => {
                const s = document.createElement('script')
                s.id = `script__${src}`
                s.async = false
                s.setAttribute('src', process.env.PUBLIC_URL + subFolder + src)
                document.body.appendChild(s)
            })
            break
        }
        case 'remove': {
            srcs.forEach(src => {
                document.getElementById(`script__${src}`).remove()
            })
            break
        }
        default:
            break
    }
}
async function assets_style(action) {
    const srcs = ['/css/common.css', '/css/editor.css', '/css/charts.css', '/controls/css/style.css']
    switch (action) {
        case 'add': {
            srcs.forEach(src => {
                const s = document.createElement('link')
                s.rel = 'stylesheet'
                s.id = `style__${src}`
                s.setAttribute('href', process.env.PUBLIC_URL + subFolder + src)
                document.head.appendChild(s)
            })
            break
        }
        case 'remove': {
            srcs.forEach(src => {
                document.getElementById(`style__${src}`).remove()
            })
            break
        }
        default:
            break
    }
}
async function assets_html(action) {
    switch (action) {
        case 'add': {
            let response = await fetch(process.env.PUBLIC_URL + subFolder + '/templates/main.html')
            let html = await response.text()
            const d = document.createElement('div')
            d.id = 'editor_legacy_dom'
            d.innerHTML = html
            document.body.appendChild(d)
            break
        }
        case 'remove': {
            document.getElementById('editor_legacy_dom').remove()
            break
        }
        default:
            break
    }
}

function setLangs(lng) {
    // Логика нейминга: i18n_<html_name>__<var_name> если к конкретному элемену, 18n__<var_name> - общие фразы
    editor_translations.forEach(el => {
        switch (el.identifier) {
            case 'id':
                if (document.getElementById(el.name)) {
                    document.getElementById(el.name).innerHTML = el.locales[lng]
                }
                break
            case 'class':
                const res = document.getElementsByClassName(el.name)
                for (let i = 0; i < res.length; i++) {
                    res[i].innerHTML = el.locales[lng]
                }
                break
            default:
                break
        }
    })
}

class Editor extends React.Component {
    _isMounted = false

    constructor(props) {
        super(props)
        this.state = {
            show_loading: false,

            project_loaded: false,
            project: null,

            og_info: {
                title: '',
                default_title: props.t('_pages._editor.project_default_title'),
                description: '',
                default_description: props.t('_pages._editor.project_default_description'),
                image_id: '',
                image_url: '',
                custom_image: false,
            },

            tab: null,
            tabs: ['editor', 'preview', 'integrations', 'review'],
            from: '',
            status: '',
            topbar: {
                name: '',
                default_name: props.t('_pages._editor.project_default_name'),
                status: 0,
                statuses: [
                    {
                        value: 0,
                        label: props.t('_pages._editor._statuses.saved'),
                    },
                    {
                        value: 1,
                        label: props.t('_pages._editor._statuses.autosaving'),
                    },
                    {
                        value: 2,
                        label: props.t('_pages._editor._statuses.saving'),
                    },
                    {
                        value: 3,
                        label: props.t('_pages._editor._statuses.publishing'),
                    },
                ],
            },

            personality_modal: {
                is_open: false,
                data: {
                    slide_id: null,
                    option_id: null,
                },
            },
            upgrade_modal: {
                is_open: false,
            },

            personalityDistribution: {
                data: null,
                isLoading: false,
            },
            triviaDistribution: {
                data: null,
                isLoading: false,
            },
        }
        this.base_state = this.state

        this.handleChange__topbar__status = this.handleChange__topbar__status.bind(this)
        this.handleChange__topbar__name = this.handleChange__topbar__name.bind(this)
        this.handleChange__show_loading = this.handleChange__show_loading.bind(this)
        this.handleChange__og_info = this.handleChange__og_info.bind(this)
        this.handleChange__project = this.handleChange__project.bind(this)
    }

    async componentDidMount() {
        this.props.P__EDITOR__MOUNT()

        this._isMounted = true

        UTILS__COMMON__KEYS_CHECKER(async () => {
            try {
                this.setState(prevState => ({
                    topbar: {
                        ...prevState.topbar,
                        status: 2,
                    },
                }))

                const project = await EditorMain.saveProject()

                this.setState(prevState => ({
                    project,
                    topbar: {
                        ...prevState.topbar,
                        status: 0,
                    },
                }))
            } catch (err) {
                console.error(err)
            }
        }, [['ControlLeft', 'ShiftLeft', 'KeyS']])
        UTILS__COMMON__KEYS_CHECKER(async () => {
            try {
                const serialized_project = await EditorMain.serializeProject(true)
                copy(JSON.stringify(serialized_project))
                Toast('success', {
                    title: this.props.t('_components._editor.project_struct_copied'),
                    time: 2000,
                })
            } catch (err) {
                console.error(err)
                Toast('error', {})
            }
        }, [
            ['ControlLeft', 'KeyE'],
            ['MetaLeft', 'KeyE'],
        ])
        UTILS__COMMON__KEYS_CHECKER(async () => {
            try {
                const activeScreen = EditorMain.getActiveScreen()
                if (activeScreen) {
                    const serialized_project = await EditorMain.serializeProject()
                    copy(JSON.stringify(serialized_project.router.screens[activeScreen]))
                } else {
                    throw new Error('No active screen')
                }
                Toast('success', {
                    title: this.props.t('_components._editor.screen_struct_copied'),
                    time: 2000,
                })
            } catch (err) {
                console.error(err)
                Toast('error', {})
            }
        }, [
            ['ControlLeft', 'KeyU'],
            ['MetaLeft', 'KeyU'],
        ])

        // const platform_type = window.ua.platform.type;
        // if (platform_type !== 'desktop') {
        //     // show msg "not available device"
        // }

        this.setState({
            show_loading: true,
        })

        // Tabs
        const { tabs } = this.state

        await this.setState({
            tab: tabs[0],
        })

        window.__HOME = process.env.PUBLIC_URL + subFolder + '/'
        await assets_html('add')
        await assets_style('add')
        await assets_script('add')

        const { tab } = this.state
        if (tab !== 'editor' && document.getElementById('editor_legacy_dom')) {
            document.getElementById('editor_legacy_dom').style.display = 'none'
        }

        EditorMain.subscribeEditor(this.onEditorRequest.bind(this))
    }

    async onEditorRequest({ method, data, callback }) {
        switch (method) {
            case 'react-project-load-start': {
                // Добавил отсюда в componentDidMount чтобы не было скачков
                // this.setState({
                //     show_loading: true
                // });
                break
            }
            case 'react-project-load-end': {
                const { from } = this.state

                if (from === 'template-gallery') {
                    const project = await EditorMain.saveProject()

                    UTILS__ROUTER__remove_query('templateId', {
                        history: this.props.history,
                        location: this.props.location,
                    })

                    UTILS__ROUTER__add_query('projectId', project.projectId, {
                        history: this.props.history,
                        location: this.props.location,
                    })
                    UTILS__ROUTER__add_query('id', project.id, {
                        history: this.props.history,
                        location: this.props.location,
                    })

                    await this.setState({
                        project,
                    })
                }

                // Langs
                const { i18n } = this.props
                const current_lng = languages.filter(el => el.value === i18n.language)[0]
                setLangs(current_lng.code)

                await this.setState({
                    show_loading: false,
                    project_loaded: true,
                })

                if (EditorMain.getProjectConfig().isBlockEditor) {
                    document.getElementById('editor_legacy_dom').style.display = 'none'
                }
                break
            }
            case 'react-project-load-error': {
                this.setState({
                    show_loading: false,
                })

                this.props.history.push(`/404`)
                break
            }

            case 'react-project-loaded--project': {
                this.setState(prevState => ({
                    from: 'my-projects',
                    status: data.projectStatus,
                    project: data,
                    topbar: {
                        ...prevState.topbar,
                        name: data.name,
                    },
                    og_info: {
                        ...prevState.og_info,
                        title: data.title,
                        description: data.description,
                        image_id: data.imageId ? data.imageId : '',
                        image_url: data.imageUrl ? data.imageUrl : '',
                        custom_image: data.customImageSelected,
                    },
                }))
                break
            }
            case 'react-project-loaded--template': {
                await this.setState(prevState => ({
                    from: 'template-gallery',
                    topbar: {
                        ...prevState.topbar,
                        name: prevState.topbar.default_name,
                    },
                    og_info: {
                        ...prevState.og_info,
                        title: prevState.og_info.default_title,
                        description: prevState.og_info.default_description,
                        image_id: '',
                        image_url: '',
                        custom_image: false,
                    },
                }))
                break
            }

            case 'react-autosave-project-start': {
                this.setState(prevState => ({
                    topbar: {
                        ...prevState.topbar,
                        status: 1,
                    },
                }))
                break
            }
            case 'react-autosave-project-end': {
                this.setState(prevState => ({
                    topbar: {
                        ...prevState.topbar,
                        status: 0,
                    },
                }))
                break
            }

            case 'request_data_layer': {
                if (data.layer_type === 'personality_chain') {
                    this.setState({
                        personality_modal: {
                            ...this.base_state.personality_modal,
                            is_open: true,
                            data: {
                                screen_id: data.screen_id,
                                option_id: data.option_id,
                            },
                        },
                    })
                }
                break
            }

            default:
                break
        }
    }

    async componentWillUnmount() {
        this.props.P__EDITOR__UNMOUNT()

        await assets_html('remove')
        await assets_style('remove')
        await assets_script('remove')

        window.Editor.unmount()
        window.getUniqId = undefined
        window.Workspace = undefined
        window.ControlManager = undefined
        window.AssistentPopup = undefined
        window.ResourceManager = undefined
        window.App = undefined
        window.directiveLoader = undefined
        window.getQueryParams = undefined
        window.RemixContainer = undefined
        window.log = undefined
        window.Auth = undefined
        window.ScreenManager.unmount()
        window.ScreenManager = undefined
        window.isNumeric = undefined
        window.SelectDialog = undefined
        window.PublishDialog = undefined
        window.ObjectPath = undefined
        window.config = undefined
        window.ControlManager = undefined
        delete window.Selector

        window.$ = undefined // must be last clean operation

        this._isMounted = false
    }

    handleInit__action = (action, payload = null) => async () => {
        switch (action) {
            case 'next': {
                const { tab, tabs } = this.state
                const new_tab = tabs[tabs.indexOf(tab) + 1]

                await this.setState({
                    tab: new_tab,
                })
                if (document.getElementById('editor_legacy_dom')) {
                    if (new_tab !== 'editor') {
                        document.getElementById('editor_legacy_dom').style.display = 'none'
                    } else if (!EditorMain.getProjectConfig().isBlockEditor) {
                        document.getElementById('editor_legacy_dom').style.display = 'block'
                    }
                }

                break
            }
            case 'publish': {
                try {
                    const accessToFeatures = await this.project_has_access_to_used_feature()

                    if (!accessToFeatures.has) {
                        this.open_upgrade_modal()

                        const necessary_features = await accessToFeatures.list_of_necessary_features
                        this.open_upgrade_modal({ necessary_features })

                        return
                    }

                    this.setState(prevState => ({
                        show_loading: true,
                        topbar: {
                            ...prevState.topbar,
                            status: 3,
                        },
                    }))

                    const {
                        og_info,
                        project: { projectId /*projectType*/ },
                    } = this.state

                    // // Check personality is OK
                    // if (projectType.customId === 'PERSONALITY') {
                    //     await this.updatePersonalityDistribution()
                    //     const { personalityDistribution } = this.state
                    //     const hasError = personalityDistribution._collision.results.neverShow.length
                    //     if (hasError) {
                    //         const quit = window.confirm('Error in distribution! Click "Cancel" to edit')
                    //         if (!quit) {
                    //             const new_tab = this.state.tabs[3]
                    //             await this.setState({
                    //                 tab: new_tab,
                    //             })
                    //             document.getElementById('editor_legacy_dom').style.display = 'none'
                    //
                    //             return
                    //         }
                    //     }
                    // }

                    let shareEntities = await EditorMain.getEditedAppSharedOptions()
                    if (!og_info.custom_image) {
                        const cvs = await EditorMain.getHtmlPreview(shareEntities.previewHtml)

                        const response_1 = await API__MEDIA.UPLOAD_IMAGE(
                            projectId,
                            'frontend_generated_image.png',
                            'image/png',
                            UTILS__CONVERT_DATA_URI_TO_BINARY(cvs.toDataURL('image/png', 0.95)),
                            true,
                            false,
                        )
                        await EditorMain.setEditedProjectPreviewImage(response_1.id)

                        await this.setState(prevState => ({
                            og_info: {
                                ...prevState.og_info,
                                image_id: response_1.id,
                                image_url: response_1.url,
                            },
                        }))
                    }
                    for (const [key, value] of Object.entries(shareEntities.entities)) {
                        if (!value.customImage || typeof value.customImage === 'undefined') {
                            const cvs = await EditorMain.getHtmlPreview(value.previewHtml)
                            const response_1 = await API__MEDIA.UPLOAD_IMAGE(
                                projectId,
                                'frontend_generated_image.png',
                                'image/png',
                                UTILS__CONVERT_DATA_URI_TO_BINARY(cvs.toDataURL('image/png', 0.95)),
                                true,
                                false,
                            )
                            shareEntities.entities[key].imageId = response_1.id
                            shareEntities.entities[key].imageUrl = response_1.url
                            if (typeof value.customImage === 'undefined') {
                                shareEntities.entities[key].customImage = false
                            }
                        }
                    }

                    await EditorMain.setEditedAppShareEntities(shareEntities)

                    const result = await EditorMain.publishProject()

                    const project = await API__PROJECTS.GET_PROJECT(result.project.projectId)

                    this.setState(prevState => ({
                        show_loading: false,
                        topbar: {
                            ...prevState.topbar,
                            status: 0,
                        },
                    }))

                    const { from, status } = this.state
                    this.props.history.push('/account/my-projects?tab=published', {
                        action: 'editor--published',
                        note: from === 'my-projects' && status.toLowerCase() === 'published' ? 'changes' : 'new',
                        data: {
                            projectUrl: project.projectVersions[0].publicUrl,
                            embedCode: result.embedCode,
                            iframeCode: '',
                        },
                    })
                } catch (err) {
                    console.error(err)
                    if (this._isMounted) {
                        this.setState(prevState => ({
                            show_loading: false,
                            topbar: {
                                ...prevState.topbar,
                                status: 0,
                            },
                        }))
                        Toast('error', {})
                    }
                } finally {
                }
                break
            }
            case 'save': {
                this.setState(prevState => ({
                    show_loading: true,
                    topbar: {
                        ...prevState.topbar,
                        status: 2,
                    },
                }))

                const project = await EditorMain.saveProject()

                this.setState(prevState => ({
                    show_loading: false,
                    project,
                    topbar: {
                        ...prevState.topbar,
                        status: 0,
                    },
                }))

                break
            }
            case 'save--silent': {
                this.setState(prevState => ({
                    topbar: {
                        ...prevState.topbar,
                        status: 2,
                    },
                }))

                const project = await EditorMain.saveProject()

                this.setState(prevState => ({
                    project,
                    topbar: {
                        ...prevState.topbar,
                        status: 0,
                    },
                }))

                break
            }
            case 'save-exit': {
                try {
                    this.setState(prevState => ({
                        show_loading: true,
                        topbar: {
                            ...prevState.topbar,
                            status: 2,
                        },
                    }))

                    const project = await EditorMain.saveProject()

                    this.setState(prevState => ({
                        show_loading: false,
                        project,
                        topbar: {
                            ...prevState.topbar,
                            status: 0,
                        },
                    }))

                    const { from, status } = this.state
                    if (from === 'my-projects') {
                        this.props.history.push(`/account/my-projects?tab=${status.toLowerCase()}`)
                        break
                    }
                    if (from === 'template-gallery') {
                        this.props.history.push('/account/my-projects?tab=drafts')
                        break
                    }
                    this.props.history.push('/account/my-projects')
                } catch (err) {
                    console.error(err)
                    if (this._isMounted) {
                        this.setState(prevState => ({
                            show_loading: false,
                            topbar: {
                                ...prevState.topbar,
                                status: 0,
                            },
                        }))
                        Toast('error', {})
                    }
                } finally {
                }
                break
            }
            case 'save-redirect': {
                try {
                    this.setState(prevState => ({
                        show_loading: true,
                        topbar: {
                            ...prevState.topbar,
                            status: 2,
                        },
                    }))

                    const project = await EditorMain.saveProject()

                    this.setState(prevState => ({
                        show_loading: false,
                        project,
                        topbar: {
                            ...prevState.topbar,
                            status: 0,
                        },
                    }))

                    this.props.history.push(payload)
                } catch (err) {
                    console.error(err)
                    if (this._isMounted) {
                        this.setState(prevState => ({
                            show_loading: false,
                            topbar: {
                                ...prevState.topbar,
                                status: 0,
                            },
                        }))
                        Toast('error', {})
                    }
                } finally {
                }
                break
            }
            default:
                break
        }
    }

    handleChange__show_loading(value) {
        this.setState({
            show_loading: value,
        })
    }

    handleChange__topbar__status(value) {
        this.setState(prevState => ({
            topbar: {
                ...prevState.topbar,
                status: value,
            },
        }))
    }
    handleChange__topbar__name(value) {
        this.setState(prevState => ({
            topbar: {
                ...prevState.topbar,
                name: value,
            },
        }))
    }
    handleClick__topbar__step = step => async evt => {
        evt.preventDefault()
        const { tabs } = this.state
        const new_tab = tabs[step]

        await this.setState({
            tab: new_tab,
        })

        if (document.getElementById('editor_legacy_dom')) {
            if (new_tab !== 'editor') {
                document.getElementById('editor_legacy_dom').style.display = 'none'
            } else if (!EditorMain.getProjectConfig().isBlockEditor) {
                document.getElementById('editor_legacy_dom').style.display = 'block'
            }
        }
    }

    handleChange__og_info(values) {
        this.setState(prevState => ({
            og_info: {
                ...prevState.og_info,
                ...values,
            },
        }))
    }

    handleChange__project(values) {
        this.setState(prevState => ({
            project: {
                ...prevState.project,
                ...values,
            },
        }))
    }

    updateTriviaDistribution = async () => {
        try {
            await this.setState(prevState => ({
                triviaDistribution: {
                    ...prevState.triviaDistribution,
                    isLoading: true,
                },
            }))
            const triviaDistribution = await EditorMain.getEditedAppTriviaDistribution()
            await this.setState(prevState => ({
                triviaDistribution: {
                    ...prevState.triviaDistribution,
                    data: triviaDistribution.result,
                },
            }))
        } catch (err) {
            console.error(err)
        } finally {
            await this.setState(prevState => ({
                triviaDistribution: {
                    ...prevState.triviaDistribution,
                    isLoading: false,
                },
            }))
        }
    }

    updatePersonalityDistribution = async (payload = null) => {
        try {
            await this.setState(prevState => ({
                personalityDistribution: {
                    ...prevState.personalityDistribution,
                    isLoading: true,
                },
            }))
            const personalityDistribution = await EditorMain.getEditedAppPersonalityDistribution(payload)
            await this.setState(prevState => ({
                personalityDistribution: {
                    ...prevState.personalityDistribution,
                    data: personalityDistribution.result,
                },
            }))
        } catch (err) {
            console.error(err)
        } finally {
            await this.setState(prevState => ({
                personalityDistribution: {
                    ...prevState.personalityDistribution,
                    isLoading: false,
                },
            }))
        }
    }
    open_personality_modal = async (screen_id = null, option_id = null) => {
        this.setState({
            personality_modal: {
                ...this.base_state.personality_modal,
                is_open: true,
                data: {
                    screen_id,
                    option_id,
                },
            },
        })
    }
    close_personality_modal = async () => {
        this.setState({
            personality_modal: {
                ...this.base_state.personality_modal,
                is_open: false,
            },
        })
    }

    close_upgrade_modal = () => {
        this.setState({
            upgrade_modal: {
                ...this.base_state.upgrade_modal,
                is_open: false,
            },
        })
    }

    open_upgrade_modal = (data = {}) => {
        this.setState({
            upgrade_modal: {
                ...this.base_state.upgrade_modal,
                is_open: true,
                data: {
                    ...this.base_state.upgrade_modal.data,
                    ...data,
                },
            },
        })
    }

    project_has_access_to_used_feature = async () => {
        const { project_features } = this.props

        const selected_feature_products = {
            LEAD_COLLECTION_FORM: EditorMain.isUsedDataCollectionFormFeature(),
        }

        const list_of_necessary_features = Object.entries(selected_feature_products)
            .filter(([feature_name, used]) => used && used !== project_features.list_of_available[feature_name])
            .map(([feature_name]) => feature_name)

        if (list_of_necessary_features.length === 0) {
            return { has: true, list_of_necessary_features }
        }

        return {
            has: false,
            list_of_necessary_features: this.get_decription_of_necessary_features(list_of_necessary_features),
        }
    }

    get_decription_of_necessary_features = async feature_names => {
        const { project_features } = this.props

        if (project_features.list_of_descriptions === null) {
            await this.props.P__PRODUCTS__SET(await API__PRODUCTS.GET_PAYMENT_PRODUCTS())

            return await this.get_decription_of_necessary_features(feature_names)
        }

        return feature_names.map(name => project_features.list_of_descriptions[name])
    }

    render() {
        const { t } = this.props
        const {
            tab,
            tabs,
            topbar,
            from,
            status,
            show_loading,
            project_loaded,
            og_info,
            project,
            personality_modal,
            upgrade_modal,
            personalityDistribution,
            triviaDistribution,
        } = this.state

        return tab ? (
            <div className="page--editor">
                <Helmet>
                    <title>{project_loaded ? `${topbar.name} | Interacty` : t('_pages._editor.project_loading')}</title>
                </Helmet>

                {/* Hidden inputs */}
                <input id="react-project-name-input" type="hidden" value={topbar.name} />
                <input id="react-project-title-input" type="hidden" value={og_info.title} />
                <input id="react-project-description-input" type="hidden" value={og_info.description} />
                <input id="react-project-image_id-input" type="hidden" value={og_info.image_id} />
                <input id="react-project-image_url-input" type="hidden" value={og_info.image_url} />
                <input id="react-project-custom_image-input" type="hidden" value={og_info.custom_image} />

                <EditorTopbar
                    name={topbar.name}
                    project_loaded={project_loaded}
                    is_published={from === 'my-projects' && status === 'PUBLISHED'}
                    step={tabs.indexOf(tab)}
                    status={topbar.statuses[topbar.status]}
                    events={{
                        change_name: this.handleChange__topbar__name,
                        change_step: this.handleClick__topbar__step,
                        init_action: this.handleInit__action,
                    }}
                />
                {project_loaded ? (
                    <div className="editor-tab">
                        {/* Tabs */}
                        {tab === 'editor' ? (
                            <EditorTab
                                project={project}
                                events={{
                                    init_action: this.handleInit__action,
                                }}
                            />
                        ) : null}
                        {tab === 'preview' ? <PreviewTab /> : null}
                        {tab === 'integrations' ? (
                            <IntegrationsTab
                                events={{
                                    init_save_silent: this.handleInit__action('save--silent'),
                                    change_step: this.handleClick__topbar__step,
                                }}
                            />
                        ) : null}
                        {tab === 'review' ? (
                            <PublishTab
                                og_info={og_info}
                                project={project}
                                data={{
                                    personalityDistribution,
                                    triviaDistribution,
                                }}
                                events={{
                                    change_step: this.handleClick__topbar__step,
                                    open_personality_modal: this.open_personality_modal,
                                    updatePersonalityDistribution: this.updatePersonalityDistribution,
                                    updateTriviaDistribution: this.updateTriviaDistribution,
                                    change_status: this.handleChange__topbar__status,
                                    init_action: this.handleInit__action,
                                    change_og_info: this.handleChange__og_info,
                                    change_project: this.handleChange__project,
                                }}
                            />
                        ) : null}

                        {/* Modals */}
                        {personality_modal.is_open ? (
                            <PersonalityOptions
                                is_open={true}
                                project={project}
                                data={personality_modal.data}
                                events={{
                                    updatePersonalityDistribution: this.updatePersonalityDistribution,
                                    init_save_silent: this.handleInit__action('save--silent'),
                                    on_close: this.close_personality_modal,
                                }}
                            />
                        ) : null}
                        {upgrade_modal.is_open ? (
                            <Upgrade
                                is_open={true}
                                overlay_close={true}
                                settings={{ max_width: 640 }}
                                events={{
                                    on_close: this.close_upgrade_modal,
                                    init_action: this.handleInit__action,
                                }}
                                necessary_features={upgrade_modal.data.necessary_features}
                            />
                        ) : null}

                        {['BLOCK_ARTICLE'].indexOf(project.projectType.customId.toUpperCase()) === -1 ? (
                            <EditorHintLayer />
                        ) : null}
                    </div>
                ) : null}
                {show_loading ? <Loader text="Project loading..." view={project_loaded ? '1-1' : '1'} /> : null}
            </div>
        ) : null
    }
}

const mapStateToProps = state => ({
    project_features: state.project_features,
})

const mapDispatchToProps = dispatch => ({
    P__PRODUCTS__SET: value => dispatch(PRODUCTS__SET(value)),
    P__EDITOR__MOUNT: () => dispatch(EDITOR__MOUNT()),
    P__EDITOR__UNMOUNT: () => dispatch(EDITOR__UNMOUNT()),
})

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation('translations'))(Editor)
